import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Announcement(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.02 2.043c.591.047 1.107.39 1.377.919l4.812 9.405a1.681 1.681 0 01-.073 1.677c-.323.514-.869.829-1.488.796-1.542-.034-4.428.081-6.971 1.217l2.52 2.999a2.343 2.343 0 01.411 2.207 2.342 2.342 0 01-1.17 1.372 2.348 2.348 0 01-2.63-.33l-3.875-3.839-1.264.648a2.355 2.355 0 01-3.165-1.022l-2.245-4.385a2.335 2.335 0 01-.143-1.795 2.328 2.328 0 011.167-1.37L7.79 7.723c.027-.014 3.394-1.797 5.728-4.991a1.69 1.69 0 011.502-.689zM10.837 16.98l-1.03.527 3.368 3.338a.35.35 0 00.353.009.347.347 0 00.176-.207.351.351 0 00-.021-.27l-2.846-3.397zM7.81 9.957l-4.617 2.365a.35.35 0 00-.153.473l2.244 4.386a.352.352 0 00.474.153l4.617-2.364L7.81 9.957zm7.026-5.653c-1.833 2.36-4.068 3.944-5.27 4.695l2.61 5.097c2.558-1.057 5.31-1.244 7.025-1.261l-4.365-8.531zm.054 2.14a1 1 0 01.484 1.329c-.823 1.765-2.748 2.691-2.965 2.79a1.001 1.001 0 01-.838-1.815c.406-.191 1.556-.888 1.99-1.82a1 1 0 011.329-.484zm8.281 2.33a1 1 0 01-.977 1.023l-1.107.024h-.023a1 1 0 01-.022-2l1.107-.023c.526-.058 1.01.424 1.022.976zm-.264-3.9a1 1 0 01-.434 1.345l-1.964 1.005a1 1 0 01-.912-1.78l1.964-1.006a1.002 1.002 0 011.346.435zM19.874 2.13c.48.27.652.88.38 1.361l-.541.965a1.001 1.001 0 01-1.744-.98l.543-.965a.997.997 0 011.362-.381z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoAnnouncement = React.memo(Announcement);
export default MemoAnnouncement;